const Applications = () => {
  const applications = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Medical Devices',
      description: 'Precision components for surgical instruments, implants, and diagnostic equipment',
      stats: '500+ Projects',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/piron-guillaume-U4FyCp3-KzY-unsplash-scaled.jpg'
    },
    {
      icon: 'ri-car-line',
      title: 'Automotive',
      description: 'High-performance engine components, fuel injection systems, and transmission parts',
      stats: '1000+ Components',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/tim-mossholder-VurHDpO4VYI-unsplash-scaled.jpg'
    },
    {
      icon: 'ri-plane-line',
      title: 'Aerospace',
      description: 'Critical aerospace components meeting stringent industry standards and regulations',
      stats: '200+ Certifications',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/spacex-9dF7pCyaM9s-unsplash-scaled.jpg'
    },
    {
      icon: 'ri-settings-4-line',
      title: 'Industrial Machinery',
      description: 'Heavy-duty components for manufacturing equipment and industrial automation',
      stats: '800+ Installations',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/photo-1455165814004-1126a7199f9b.jpg'
    },
  ];

  return (
    <section id="applications" className="py-24 bg-gradient-to-b from-[#001E3C] to-[#002A4E] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-1/2 left-0 w-1/3 h-1/3 bg-[#00D9C9]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-[#0066FF]/5 rounded-full blur-3xl"></div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#00D9C9] text-sm font-semibold tracking-wider uppercase">Industries We Serve</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Powering Innovation Across Sectors
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Our precision manufacturing solutions drive excellence in diverse industries worldwide
          </p>
        </div>

        {/* Applications Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {applications.map((app, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden hover:bg-white/10 hover:border-[#00D9C9]/50 transition-all duration-500"
            >
              {/* Image Section */}
              <div className="relative h-64 overflow-hidden">
                <div className="w-full h-full">
                  <img
                    src={app.image}
                    alt={app.title}
                    className="w-full h-full object-cover object-center transform group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#001E3C] via-[#001E3C]/50 to-transparent"></div>
                
                {/* Icon */}
                <div className="absolute top-6 left-6">
                  <div className="w-14 h-14 bg-[#00D9C9] rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className={`${app.icon} text-2xl text-[#001E3C]`}></i>
                  </div>
                </div>

                {/* Stats Badge */}
                <div className="absolute top-6 right-6">
                  <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2">
                    <span className="text-white text-sm font-semibold">{app.stats}</span>
                  </div>
                </div>
              </div>

              {/* Content Section */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-[#00D9C9] transition-colors duration-300">
                  {app.title}
                </h3>
                <p className="text-white/70 mb-6 leading-relaxed">
                  {app.description}
                </p>
                
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 text-[#00D9C9] font-semibold group-hover:gap-4 transition-all duration-300 whitespace-nowrap"
                >
                  Explore Solutions
                  <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
                </a>
              </div>

              {/* Decorative Line */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-[#00D9C9] to-[#0066FF] group-hover:w-full transition-all duration-700"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Applications;
